module.exports = __webpack_public_path__ + "assets/images/964d35254e11dad9d15d19d7093c4a50.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/portfolio/ccc-web/ccc-web-0.jpg
// module id = 804
// module chunks = 0